module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/qzj_register_privacy_new_10.png";